import styles from './InfoBox.module.scss'

export const InfoBox = ({ children }) => {
	return <div className={styles.wrapper}>{children}</div>
}
